import { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import {
  CUSTOM_BUTTON_COLOR,
  CUSTOM_BUTTON_SIZE,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
} from 'src/components/CustomButton';
import { OverflowItems } from 'src/components/OverflowItems';
import { TruncatedSpan } from 'src/components/TruncatedSpan';

import { ACTION } from '../../const';

import { useStyles } from './useStyles';

export const FooterInstructions = ({ className, instructions, onAction }) => {
  const styles = useStyles();

  const handleInsertInstruction = useCallback(
    (instruction) => {
      onAction(ACTION.insertInstruction, { instruction });
    },
    [onAction]
  );

  if (!instructions.length) {
    return;
  }

  return (
    <div className={cx(className, styles.root)}>
      <OverflowItems
        items={instructions}
        flexGap={4}
      >
        {instructions.map((instruction) => (
          <CustomButton
            className={styles.button}
            key={instruction.id}
            variant={CUSTOM_BUTTON_VARIANT.text}
            size={CUSTOM_BUTTON_SIZE.smaller}
            color={CUSTOM_BUTTON_COLOR.default}
            onClick={() => handleInsertInstruction(instruction)}
          >
            <TruncatedSpan>{instruction.text}</TruncatedSpan>
          </CustomButton>
        ))}
      </OverflowItems>
    </div>
  );
};

FooterInstructions.propTypes = {
  className: PropTypes.string,
  instructions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onAction: PropTypes.func.isRequired,
};
FooterInstructions.defaultProps = {
  className: null,
};
